import { useMemo } from "react";
import { classNames } from "../../support/formatters/class-formatter";
import { Text } from "../text";

import type { EmptyStateDescriptionProps } from "./empty-state.types";

import styles from "./empty-state-description.module.css";

export function EmptyStateDescription({
  as = "p",
  children,
  className = "",
  variant = "body-regular-medium",
  ...props
}: EmptyStateDescriptionProps) {
  const mountedClassName = useMemo(() => {
    return classNames(styles.Container, styles[variant], className);
  }, [className, variant]);

  return (
    <Text as={as} className={mountedClassName} variant={variant} {...props}>
      {children}
    </Text>
  );
}
